export const version = "1.7.17-daily-20260813-0";
export const channel = "daily";
export const gitcommit = "29155b4ee";
